import { Controller } from "@hotwired/stimulus"

// Submits the parent form when a landlord is chosen from the registry dropdown.
export default class extends Controller {
  assign() {
    this.element.requestSubmit()
  }
}
